// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/mnt/builds-ssd/TiznJeV8v/0/lumidrama/lumidrama-center-client/src/models/configModel';
import model_2 from '/mnt/builds-ssd/TiznJeV8v/0/lumidrama/lumidrama-center-client/src/models/tagsViewModel';
import model_3 from '/mnt/builds-ssd/TiznJeV8v/0/lumidrama/lumidrama-center-client/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'configModel', model: model_1 },
model_2: { namespace: 'tagsViewModel', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
} as const
